import { usersRepo } from '@/constants/providers';
import { useMutation } from '@tanstack/react-query';

export const useUpdateLastAccess = () =>
  useMutation(() => usersRepo.updateLastAccess());
